import styled from 'styled-components'

export const Container = styled.div`
  height: calc(100vh - 54px);
`

export const Slider = styled.div`
  height: 100%;

  .slider {
    position: relative;
    height: 100%;

    .slick-slider {
      .slick-dots {
        width: auto;
        bottom: 32px;
        left: 24px;

        li {
          width: 24px;
          margin: 0 8px 0 0;
          opacity: 1;
          transition: all 0.3s linear;
          background: var(--gray200);

          &.slick-active {
            width: 24px;
            background: var(--primary500);
          }
        }
      }
    }
  }
`
export const SliderContentWrapper = styled.div`
  margin-top: 24px;

  img {
    max-width: 100%;
    height: auto;
  }
`

export const SliderContent = styled.div`
  padding: 24px;

  h1 {
    margin-bottom: 8px;
  }

  svg {
    width: 64px;
    height: 64px;
    padding: 16px;
    border-radius: 8px;
    background-color: var(--gray100);
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
